import React from 'react';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-sage-green text-center" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <h2 className="font-fredoka text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-42">
          ¿Sigues dudando mientras otra noche pasa sin rezar con tu hijo?
        </h2>

        <p className="text-xl md:text-2xl text-white/90 font-medium mb-12 max-w-3xl mx-auto" data-id="element-43">
          Por menos que un cuaderno escolar puedes tener el método que
          transforma la oración en el momento favorito de tu familia desde hoy
          mismo.
        </p>

        <a href="https://pequeguia.lat/cart/42347593236583:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-white text-sage-green hover:bg-gray-50 font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 mb-6 text-center" data-id="element-44">
          SÍ, QUIERO CRIAR CON FE POR $3.900 CLP
        </a>

        <p className="text-white/80 font-medium text-lg" data-id="element-45">
          Descarga inmediata. Garantía 7 días. Pago 100% seguro.
        </p>
      </div>
    </section>;
}